import React from "react";
import Header from "./Header";
import Task from "./Task";

const Taskboard = () => {
	return (
		<div>
			<Header />
			<Task />
		</div>
	);
};

export default Taskboard;
